/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Role removal data
 * @export
 * @interface AssignRoleRequest
 */
export interface AssignRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignRoleRequest
     */
    userId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignRoleRequest
     */
    roleIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssignRoleRequest
     */
    tenantId?: string;
}

/**
 * Check if a given object implements the AssignRoleRequest interface.
 */
export function instanceOfAssignRoleRequest(value: object): value is AssignRoleRequest {
    return true;
}

export function AssignRoleRequestFromJSON(json: any): AssignRoleRequest {
    return AssignRoleRequestFromJSONTyped(json, false);
}

export function AssignRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignRoleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'roleIds': json['roleIds'] == null ? undefined : json['roleIds'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
    };
}

export function AssignRoleRequestToJSON(json: any): AssignRoleRequest {
    return AssignRoleRequestToJSONTyped(json, false);
}

export function AssignRoleRequestToJSONTyped(value?: AssignRoleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'roleIds': value['roleIds'],
        'tenantId': value['tenantId'],
    };
}

